export default "__VITE_ASSET__C03cJ1RA__"